import React from 'react';
import { unmountComponentAtNode, render } from 'react-dom';
import { IArrowTipsProps, ArrowTips } from '@com/guides-line/arrow-tips';

let _container;

const getContainer = () => {
    const container = document.querySelector('#customMessageWrapper');
    if (!container) {
        const container = document.createElement('div');
        document.body.appendChild(container);
        return container;
    }
    return container;
};


const hideTips = () => {
    if (_container) {
        unmountComponentAtNode(_container);
        document.body.removeChild(_container);
        _container = undefined;
    }
};


const showTips = (props: IArrowTipsProps) => {
    if (!_container) {
        _container = getContainer() as HTMLDivElement;
    }

    render(
        <ArrowTips
            {...props}
        />,
        _container,
    );
};
export default {
    showTips,
    hideTips,
};

